<template>

  <div>
    <treeselect
      :value="value"
      @input="changed($event)"
      :options="options"
      :normalizer="normalizer"
      :multiple="true"
      :limit="1"
      :placeholder="$t('entityNames.assets')"
      :clearAllText="$t('clear')"
      :limitText="(n) => $t('and-more', [n])"
      :flat="true"
      :appendToBody="true"
      :autoSelectDescendants="!selectSelf"
      :autoDeselectDescendants="!selectSelf"
      auto-focus
    />
  </div>

</template>

<script>

export default {
  name: 'assets-tree',

  props: [ 'value', 'shvDisabled', 'selectSelf' ],

  data () {
    return {
      tree: {},
      options: []
    }
  },

  methods: {
    normalizer (node) {
      return {
        id: node.id,
        label: node.name,
        children: node.children && node.children.length
                  ? (!this.shvDisabled || node.getAllChildren().some(a => !a.isDisabled) ? node.children : undefined)
                  : undefined
      }
    },

    changed (event) {
      this.$emit('input', event)

      if (event && this.tree && this.tree.nodes)
        this.$emit('assets', this.tree.nodes.filter(x => event.includes(x.id)))
    }
  },

  async created () {
    await this.$store.dispatch('getStaticItems', { model: { name: 'assets', tree: true } })

    this.tree = this.$store.state.staticItems['assets'].clone()
    this.tree.nodes = this.tree.nodes
                      .map(asset => Object.assign(asset, { isDisabled: this.shvDisabled && asset.shvPath === null }))
                      .filter(asset => asset.getSelfAndAllChildren().some(a => !a.isDisabled))

    this.options = this.tree.roots()

    this.changed(this.value)
  },
}

</script>

<style lang="scss">

  .vue-treeselect--append-to-body {
    font-family: 'Roboto', sans-serif;
    line-height: 1.5;
    font-size: 14px;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.87);

    .vue-treeselect__option {
      margin-top: 3px;
    }
  }

</style>
